module.exports = __webpack_public_path__ + "img/save.e4ca9ec0.png";